import type { SVGProps } from "react";

export function IconDarkPurplePersonCheck(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6191_11746)">
        <path
          d="M24.75 10.3125L26.8125 12.375L31.625 7.5625M19.9375 28.875V24.75M8.9375 28.875V24.75M4.125 28.875V19.25H24.75V28.875H4.125ZM19.9375 8.25C19.9375 11.2876 17.4751 13.75 14.4375 13.75C11.3999 13.75 8.9375 11.2876 8.9375 8.25C8.9375 5.21243 11.3999 2.75 14.4375 2.75C17.4751 2.75 19.9375 5.21243 19.9375 8.25Z"
          stroke="#3E2247"
          strokeWidth="2.0625"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_6191_11746">
          <rect width="33" height="33" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
